<template>
    <PromoBanner
        v-if="incorrectOrientation"
        :description="$tr('rotateMessage.message', { orientation: trOrientation })"
        :image="{
            src: RotateHorizontalIcon,
            alt: $tr('rotateMessage.rotate'),
            class: (incorrectOrientation === 'horizontal' && $style.rotate_vertical) || undefined,
        }"
        :titleProps="{ type: 'label', size: 'l' }"
        direction="row"
        :class="[$style.banner_override, props.class]"
        :title="$tr('rotateMessage.rotate')"
        textAlign="left"
        :closeBtnProps="{ visual: 'fill' }"
        @closePromo="emit('close')"
    />
</template>

<script lang="ts" setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'

import PromoBanner from '@/components_new/PromoItems/PromoBanner.vue'
import { useTr } from '@/composables/use-tr'
import { useAppStore } from '@/store/app-store'

import RotateHorizontalIcon from './icons/rotate-horizontal.svg'

export type Orientation = 'horizontal' | 'vertical'
interface RotateMessageProps {
    orientation: Orientation[]
    class?: string
}

const props = defineProps<RotateMessageProps>()

const { platform } = useAppStore()
const tr = useTr()

const incorrectOrientation = ref<Orientation | undefined>()

const portraitMediaQuery = ref<MediaQueryList | null>(null)

const emit = defineEmits<{
    close: []
}>()

const onOrientationChange = () => {
    const screenOrientation = portraitMediaQuery.value?.matches ? 'vertical' : 'horizontal'
    if (props.orientation.includes(screenOrientation)) {
        incorrectOrientation.value = undefined
    } else {
        incorrectOrientation.value = screenOrientation
    }
}

const trOrientation = computed(() => {
    if (props.orientation[0] === 'horizontal') {
        return tr('orientationLabel.horizontalOrientation')
    } else if (props.orientation[0] === 'vertical') {
        return tr('orientationLabel.verticalOrientation')
    } else {
        return props.orientation[0]
    }
})

onMounted(() => {
    if (platform !== 'desktop' && props.orientation.length !== 2) {
        portraitMediaQuery.value = window.matchMedia('(orientation: portrait)')
        // temp solution for widgets
        portraitMediaQuery.value.addEventListener('change', onOrientationChange)
        onOrientationChange()
    }
})

onUnmounted(() => {
    portraitMediaQuery.value?.removeEventListener('change', onOrientationChange)
})
</script>

<style module>
.banner_override {
    display: flex;
    min-width: 250px;
    max-width: 264px;
}

.image {
    width: 64px;
    height: 64px;
    object-fit: contain;
}

.rotate_vertical {
    transform: rotate(-90deg);
}
</style>
